export default {"src":"/_next/static/media/Line.21a33636.svg","height":1,"width":300,"blurWidth":0,"blurHeight":0};